import { Component } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import {
  NzFormControlComponent,
  NzFormLabelComponent,
  NzFormModule,
} from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';

interface ObjectivesList {
  key: string;
  sequence: string;
  objectives: number;
  action: string;
}

@Component({
  selector: 'app-edit-workshop',
  standalone: true,
  imports: [
    NzFormModule,
    NzButtonModule,
    NzFormLabelComponent,
    NzFormControlComponent,
    NzInputModule,
    NzCheckboxModule,
    NzSelectModule,
    NzUploadModule,
    SvgIconComponent,
    NzTableModule,
    CdkDropList,
    CdkDrag,
    DragDropModule,
  ],
  templateUrl: './edit-workshop.component.html',
  styleUrl: './edit-workshop.component.scss',
})
export class EditWorkshopComponent {
  listOfData: ObjectivesList[] = [
    {
      key: '1',
      sequence: '1',
      objectives: 20,
      action: '',
    },
    {
      key: '2',
      sequence: '2',
      objectives: 32,
      action: '',
    },
    {
      key: '3',
      sequence: '3',
      objectives: 39,
      action: '',
    },
  ];
  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.listOfData, event.previousIndex, event.currentIndex);
  }
}
